module.exports = __webpack_public_path__ + "static/media/loc7_img5.f1bfffe0.jpg";